import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getOrganizationById,
  updateOrganization,
  createOrganization,
  deleteOrganization,
} from './organizationApi';
import { toast } from 'react-toastify';

export const useGetOrganizationById = (orgId) => {
  return useQuery({
    enabled: !!orgId,
    queryKey: ['organization', orgId],
    queryFn: () => getOrganizationById(orgId),
    onError: (error) => {
      console.error('Error fetching organization:', error);
      toast.error(error.response?.data?.message || 'Failed to fetch organization details');
    }
  });
};

export const useCreateOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['create_org'],
    mutationFn: createOrganization,
    onSuccess: (response) => {
      const data = response?.data || response;
      if (!data || (!data.id && !data._id && !data.organizationId)) {
        throw new Error('Invalid organization data received from server');
      }
      queryClient.invalidateQueries(['organization']);
      queryClient.invalidateQueries(['user']);
      toast.success('Organization created successfully');
      
      return data;
    },
    onError: (error) => {
      console.error('Error creating organization:', error);
      toast.error(error.response?.data?.message || 'Failed to create organization');
      throw error;
    },
  });
};

export const useUpdateOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['update_org'],
    mutationFn: updateOrganization,
    onSuccess: (data) => {
      if (!data) {
        throw new Error('No data received from server');
      }
      queryClient.invalidateQueries(['organization']);
      toast.success('Organization updated successfully');
    },
    onError: (error) => {
      console.error('Error updating organization:', error);
      toast.error(error.response?.data?.message || 'Failed to update organization');
    },
  });
};

export const useDeleteOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['delete_org'],
    mutationFn: deleteOrganization,
    onSuccess: () => {
      queryClient.invalidateQueries(['organization']);
      toast.success('Organization deleted successfully');
    },
    onError: (error) => {
      console.error('Error deleting organization:', error);
      toast.error(error.response?.data?.message || 'Failed to delete organization');
    },
  });
};
